import CloseIcon from "@mui/icons-material/Close";

export function ViewLeaveForm({ isOpen, onClose, viewData }) {
	const handleClose = () => {
		onClose();
	};

	return (
		<>
			<div className={`modal-overlay ${isOpen ? "open" : ""}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>Reference Details</h3>
							</div>
							<div className="popUp-close">
								<CloseIcon onClick={() => handleClose()} />
							</div>
						</div>
						<div className="popUp-body">
							<div className="popUp-item info-item column">
								<div className="info-item-label">Employee</div>
								<div className="info-item-input">
									<input
										readOnly={true}
										id="employeePersonalInformationFullNameLeave"
										placeholder="Employee"
										value={viewData.employeePersonalInformationFullName}
									/>
								</div>
							</div>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Leave Type</div>
								<div className="info-item-input">
									<input
										readOnly={true}
										id="employeePersonalInformationFullNameLeave"
										placeholder="Employee"
										value={viewData.leaveTypeDescription}
									/>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Date From</div>
									<div className="info-item-input">
										<input
											readOnly={true}
											id="employeePersonalInformationFullNameLeave"
											placeholder="Employee"
											value={viewData.dateFrom}
										/>
									</div>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Date To</div>
									<div className="info-item-input">
										<input
											readOnly={true}
											id="employeePersonalInformationFullNameLeave"
											placeholder="Employee"
											value={viewData.dateTo}
										/>
									</div>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Days</div>
									<div className="info-item-input">
										<input
											readOnly
											type="number"
											id="daysLeave"
											placeholder="Days"
											value={viewData.days}
										/>
									</div>
								</div>
							</div>
							<div className="transaction-from-splitItem row">
								<div className="transaction-form-item row">
									<div
										className="transaction-form-input"
										style={{ width: "auto" }}
									>
										<input
											type="checkbox"
											readOnly
											id="overtime-allowance"
											className="checkbox"
											name=""
											checked={viewData.isHalfDay}
										/>
									</div>
									<div
										className="transaction-form-category"
										style={{ padding: "0 10px" }}
									>
										<h5 style={{ fontWeight: "normal" }}>Half Day?</h5>
									</div>
								</div>
							</div>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Reason</div>
								<div className="info-item-input">
									<textarea
										id="tamper"
										className="filterSelect"
										style={{
											width: "100%",
											minHeight: "50px",
											borderRadius: "3px",
											border: "1px solid #80808080",
											color: "rgb(104, 104, 104)",
										}}
										value={viewData.reason}
										readOnly
									/>
								</div>
							</div>
						</div>
						<div
							className="buttons row"
							style={{ justifyContent: "end", padding: "20px 40px" }}
						>
							<button
								id="add-family"
								className="cancel row"
								onClick={handleClose}
							>
								Close
							</button>
						</div>
					</div>
				)}
			</div>
		</>
	);
}